export default "__VITE_ASSET__AELOEuyd__"